import { render, staticRenderFns } from "./DictionaryAcceptancesIndex.vue?vue&type=template&id=088c6a0a&scoped=true&"
import script from "./DictionaryAcceptancesIndex.vue?vue&type=script&lang=js&"
export * from "./DictionaryAcceptancesIndex.vue?vue&type=script&lang=js&"
import style0 from "./DictionaryAcceptancesIndex.vue?vue&type=style&index=0&id=088c6a0a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "088c6a0a",
  null
  
)

export default component.exports